
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/languages",
      function () {
        return require("private-next-pages/languages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/languages"])
      });
    }
  